import React, { useState } from "react";
import { APISD } from "../../../../../../config/apisd";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export function StudentAvatar({ photo, size = 44, portrait = false }) {

  const [failedPhoto, setFailedPhoto] = useState(null);

  if (photo && failedPhoto !== photo) return (
    <img 
      src={photo} 
      alt="Foto siswa" 
      className="sims-student-avatar" 
      style={{ width: size, height: portrait ? size * 4 / 3 : size, borderRadius: portrait ? 0 : "50%", objectFit: "cover" }}
      onError={() => setFailedPhoto(photo)}
    />
  );

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      role="img" 
      aria-label="Foto belum tersedia" 
      className="sims-student-avatar"
    >
      <defs>
        <linearGradient 
          id="sims-avatar-gradient" 
          x1="0" 
          y1="0" 
          x2="1" 
          y2="1"
        >
          <stop stopColor="#08b7eb" />
          <stop offset="1" stopColor="#4740f8" />
        </linearGradient>
        
        <linearGradient 
          id="sims-avatar-person" 
          x1="0" 
          y1="0" 
          x2="0" 
          y2="1"
        >
          <stop stopColor="#f4fbff" />
          <stop offset="1" stopColor="#c5e6ff" />
        </linearGradient>
      </defs>

      <circle cx="50" cy="50" r="49" fill="url(#sims-avatar-gradient)" />

      <circle cx="50" cy="34" r="14" fill="#eff9ff" />

      <path d="M24 75c0-17 11-27 26-27s26 10 26 27v2c-7 8-16 11-26 11s-19-3-26-11z" fill="url(#sims-avatar-person)" />
    </svg>
  );
}

export function studentPhoto(student) {
  const photo = [student?.foto_path, student?.foto, student?.photo, student?.profile_photo]
    .find((value) => typeof value === "string" && value.trim());
  if (!photo) return null;

  const path = photo.trim();
  if (/^(https?:\/\/|data:image\/|blob:)/i.test(path)) return path;
  if (!path.startsWith("/") && !path.startsWith("api/")) return null;

  const baseURL = APISD.defaults?.baseURL;
  if (!baseURL) return path.startsWith("/") ? path : `/${path}`;
  try {
    const frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined;
    const apiURL = new URL(baseURL, frontendOrigin);
    return new URL(path.startsWith("/") ? path : `/${path}`, apiURL.origin).href;
  } catch {
    return null;
  }
};

function photoTitle(value) {
  return String(value || "").toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export default function PreviewFoto({ student, onHide, ...props }) {

  const photo = studentPhoto(student);
  
  return (
    <Modal
      {...props}
      centered
      keyboard={false}
      onHide={onHide}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-preview-photo"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-preview-photo" className="sims-modal-title">Foto Siswa</h5>
        </div>
        <button type="button" className="sims-modal-close" onClick={onHide} aria-label="Tutup modal">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className="sims-modal-body">
        <div className="sims-photo-preview">
          <StudentAvatar photo={photo} size={280} portrait />
        </div>
        
        <strong className="sims-preview-name">
          {photoTitle(student?.nama_siswa || student?.name_student) || "Siswa"}
        </strong>

        {!photo && <span className="sims-preview-empty">Foto profil belum tersedia.</span>}
      </div>

      <div className="sims-modal-footer">
        <button type="button" className="sims-modal-cancel" onClick={onHide}>Tutup</button>
      </div>

    </Modal>
  );
}
